import Vue from 'vue'
import VueResource from 'vue-resource'
// import Interceptor from './interceptor'
import store from 'state/store'

Vue.use(VueResource)

// const interceptor = new Interceptor()

export const host =
  window.location.hostname.search(/mindsocial/i) !== -1 ? 'mindsocial' : 'fuht'

// HTTP
Vue.http.options.root = (process.env.NODE_ENV === 'production' ? `https://api.${host}.dk/wp-json/pp/v1` : 'http://api.fuht.test/wp-json/pp/v1')
Vue.http.options.crossOrigin = true
Vue.http.options.xhr = { withCredentials: true }

Vue.http.interceptors.push((request, next) => {
  const token = store._modules.auth.state.token

  if (token && !request.headers.Authorization) {
    // Only apply auth header if not set — e.g. on login
    request.headers.Authorization = `Bearer ${token}`
  }

  // console.log('%crequest', 'font-weight: bold; color: green', request)

  // continue to next interceptor
  next(response => {
    response.data = response.json()
  })
})

export const Login = Vue.resource('auth')
export const Logout = Vue.resource('auth/invalidate')
export const Exercises = Vue.resource('exercises')
export const PredefinedExercises = Vue.resource('exercises/predefined')
export const SurveyTypes = Vue.resource('survey/types')
export const Exercise = Vue.resource('exercises/{id}')
export const Teams = Vue.resource('me/teams')
export const Sessions = Vue.resource('me/teams/{id}/sessions')
export const RefreshToken = Vue.resource('auth/refresh')
export const Survey = Vue.resource('me/teams/{id}/survey/{type}')
export const PreSurvey = Vue.resource('me/teams/{id}/survey/pre')
export const PostSurvey = Vue.resource('me/teams/{id}/survey/post')
// export const SharpBrainsSurvey = Vue.resource(
//   'me/teams/{id}/survey/sharp_brains'
// )
export const http = Vue.http



// WEBPACK FOOTER //
// ./src/api/resources.js